export { PricePage as default } from '@/components/enpages/Ir/Stock/Price'
